import * as styled from '../styles/hero-backdrop';

export const HeroBackdrop = () => (
  <styled.Layer aria-hidden="true">
    <styled.Grid />
    <styled.OrbGreen />
    <styled.OrbSky />
  </styled.Layer>
);
